import { mdiMagnifyMinusOutline } from '@mdi/js';
import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class ZoomOutButton extends Command {
    constructor() {
        const isEnabled = true;
        // ToDO: if (GlobalVariables.docRender !== undefined) {
        //   isEnabled = GlobalVariables.getPDFPageRenderScale() > GlobalVariables.docRender.pdfViewer.config.minScale;
        // }

        const key = 'zoomOut';
        GlobalVariables.registeredCommands[key] = () => {
            GlobalVariables.zoom('out');
        };

        super({
            Enabled: isEnabled,
            Key: key,
            Path: mdiMagnifyMinusOutline,
            Callback: GlobalVariables.registeredCommands[key],
        });
    }
}
